function fadeInReplacement(element, replacement) {
  element.style.opacity = "0";
  element.innerHTML = replacement.innerHTML;
  element.classList.add("animate--fadeIn--fast");
  element.addEventListener("animationend", function () {
    element.style.opacity = "1";
    element.classList.remove("animate--fadeIn--fast");
  });
}

function serializeArray(form) {
  var field,
    l,
    s = [];
  if (typeof form == "object" && form.nodeName == "FORM") {
    var len = form.elements.length;
    for (var i = 0; i < len; i++) {
      field = form.elements[i];
      if (
        field.name &&
        !field.disabled &&
        field.type != "file" &&
        field.type != "reset" &&
        field.type != "submit" &&
        field.type != "button"
      ) {
        if (field.type == "select-multiple") {
          l = form.elements[i].options.length;
          for (j = 0; j < l; j++) {
            if (field.options[j].selected)
              s[s.length] = { name: field.name, value: field.options[j].value };
          }
        } else if (
          (field.type != "checkbox" && field.type != "radio") ||
          field.checked
        ) {
          s[s.length] = { name: field.name, value: field.value };
        }
      }
    }
  }
  return s;
}

function updateProductMedia(selectedVariant) {
  const productMedia = document.querySelectorAll(".product-gallery-image");

  if (selectedVariant.featured_image) {
    // // console.log("image id = " + selectedVariant.featured_image.id);

    let variantId = selectedVariant.id;

    productMedia.forEach((image) => {
      if (image.dataset.variant && image.dataset.variant == variantId) {
        image.classList.add("selected");
        image.classList.remove("visually-hidden");
      } else if (image.dataset.variant) {
        image.classList.remove("selected");
        image.classList.add("visually-hidden");
      } else {
        image.classList.remove("selected");
      }
    });

    if (window.matchMedia("(max-width: 800px)").matches) {
      const mediaContainer = document.querySelector(".product-main__gallery");
      if (mediaContainer) {
        // console.log("scroll to image");
        mediaContainer.scrollTo({ left: 0, behavior: "smooth" });
      }
    }
  } else {
    productMedia.forEach((image) => {
      image.classList.remove("selected");
    });
  }
}

function updateURL(selectedVariant) {
  if (selectedVariant) {
    window.history.replaceState(null, null, "?variant=" + selectedVariant.id);
  }
}

function updateInputs(selectedVariant, form, pickerInput) {


  let id = form.querySelector(".js-variant-id"),
    qty = form.querySelector(".js-variant-qty"),
    management = form.querySelector(".js-variant-management"),
    policy = form.querySelector(".js-policy"),
    availability = form.querySelector(".js-availability"),
    name = form.querySelector(".js-name"),
    price = form.querySelector(".js-price"),
    comparePrice = form.querySelector(".js-compare-at-price");

  if (selectedVariant) {
    if (id && id.value != null) id.value = selectedVariant.id;
    if (management && management.value != null)
      management.value = selectedVariant.inventory_management;
    if (policy && policy.value != null)
      policy.value = selectedVariant.inventory_policy;
    if (availability && availability.value != null)
      availability.value = selectedVariant.available;
    if (name && name.value != null) name.value = selectedVariant.title;
    if (price && price.value != null) price.value = selectedVariant.price;
    if (comparePrice && comparePrice.value != null)
      comparePrice.value = selectedVariant.compare_at_price;
  }

  if (management.value === "shopify") {
    qty.value = selectedVariant.inventory_quantity;
    if (pickerInput) {
      pickerInput.setAttribute("max", selectedVariant.inventory_quantity);
      pickerInput.setAttribute("ariavaluemax", selectedVariant.inventory_quantity);   
    }
  } else {
    qty.value = 1000;

    if (pickerInput) {
      pickerInput.setAttribute("max", 1000);
      pickerInput.setAttribute("ariavaluemax", 1000);
    }
  }
}

function cartConfirmation(button) {
  setTimeout(() => {
    button.classList.add("confirmation");
    button.setAttribute("disabled", true);
  }, 600);


  setTimeout(() => {
    
    let itemIncart = button.classList.contains("disabled--item-in-cart");
    button.classList.remove("confirmation");

    if (!itemIncart) {
      button.removeAttribute("disabled");
    }
  }, 5000);
}

function toggleMiniCart() {
  var miniCart = document.getElementById("mini-cart");

  if (html.classList.contains("mini-cart-open")) {
    if (togglePopoverSupported) {
      miniCart.hidePopover();
    }
    miniCart.classList.remove("mini-cart-open");
    html.classList.remove("mini-cart-open");
  } else {
    if (togglePopoverSupported) {
      miniCart.showPopover();
    }
    miniCart.classList.add("mini-cart-open");
    html.classList.add("mini-cart-open");
  }
}

function updateCartItemCounts(dataCartItemCount, dataCartContents) {
  const cartItemCounts = document.querySelectorAll(".js-cart-count"),
    cartItemTotals = document.querySelectorAll(".js-cart-total");

  cartItemCounts.forEach((count) => {
    count.textContent = dataCartItemCount;
  });

  cartItemTotals.forEach((total) => {
    total.textContent = dataCartContents.dataset.cartTotal;
  });

  // if (cartCheck) {
  //     cartTotal.textContent = dataCartContents.dataset.cartTotal;
  // }
}

function updateCartContents(
  dataCartContents,
  miniCartContents,
  cartPageContents,
  contents,
) {
  // Update cart page contents if we're on the cart page
  if (cartPageContents && dataCartContents) {
    cartPageContents.innerHTML = dataCartContents.innerHTML;
  }
  // Update mini cart contents if mini cart is open
  if (miniCartContents && dataCartContents && lineItem.isInMiniCart(contents)) {
    miniCartContents.innerHTML = dataCartContents.innerHTML;
  }
}

function updateMiniCartLine(items, dataLineItems) {
  items.forEach((item) => {
    const lineItemId = item.id;
    const matchingLineItem = Array.from(dataLineItems).find(
      (item) => item.id === lineItemId,
    );

    if (matchingLineItem) {
      const lineItemInfo = matchingLineItem.querySelector(
        ".line-item__price",
      );
      const itemInfo = item.querySelector(".line-item__price");

      // Add null checks before accessing innerHTML
      if (lineItemInfo && itemInfo && lineItemInfo.innerHTML !== itemInfo.innerHTML) {
        fadeInReplacement(itemInfo, lineItemInfo);
      }
    }
  });
}

function updateRemoveLines() {
  // console.log("updateRemoveLines");
  const removeLines = document.querySelectorAll(
    ".cart-contents .js-remove-line",
  );
  removeLines.forEach((line) => {
    line.addEventListener("click", lineItem.onLineRemoved);
  });
}
function updateCartItems(
  remove,
  dataCartItemCount,
  dataCartContents,
  miniCartContents,
  cartPageContents,
  contents,
) {
  // Update cart item counts and totals
  // console.log(" updateCartItems");
  // console.log("remove = " + remove);
  let cartItemCounts = document.querySelectorAll(".js-cart-count");

  if (remove) {
    // If removing an item, check if cart is empty, if so, remove all contents, if not, update contents
    cartItemCounts.forEach((count) => {
      count.textContent = dataCartItemCount;
    });

    if (lineItem.isInMiniCart(contents)) {
      if (dataCartItemCount <= 0) {
        // console.log("remove all");
        if (miniCartContents.innerHTML !== dataCartContents.innerHTML) {
          fadeInReplacement(miniCartContents, dataCartContents);
        }
      } else {
        if (miniCartContents.innerHTML !== dataCartContents.innerHTML) {
          fadeInReplacement(miniCartContents, dataCartContents);
        }
      }
    } else {
      // console.log("remove");
      if (dataCartItemCount <= 0) {
        // console.log("remove all");
        if (cartPageContents.innerHTML !== dataCartContents.innerHTML) {
          fadeInReplacement(cartPageContents, dataCartContents);
        }
        let headerCart = document.querySelector(".js-cart-status");

        if (headerCart) {
          headerCart.classList.add("empty");
          headerCart.classList.remove("has-items");
        }
      } else {
        if (cartPageContents.innerHTML !== dataCartContents.innerHTML) {
          fadeInReplacement(cartPageContents, dataCartContents);
        }
      }
    }
  } else {
    let cartLineItems = document.querySelectorAll(".line-item"),
      dataLineItems = dataCartContents.querySelectorAll(".line-item");

    cartLineItems.forEach((item) => {
      let lineItemId = item.id,
        matchingLineItem = Array.from(dataLineItems).find(
          (item) => item.id === lineItemId,
        );

      if (matchingLineItem) {
        // // console.log('match')
        let lineItemInfo = matchingLineItem.querySelector(
            ".line-item__price",
          ),
          itemInfo = item.querySelector(".line-item__price");

        if (lineItemInfo.innerHTML !== itemInfo.innerHTML) {
          fadeInReplacement(itemInfo, lineItemInfo);
        }
      }
    });
  }
}

// Loop through cart, check variant ids and compare with the selected variant id
// If the variant id matches, update the quantity input with the new quantity
// If the quantity is 0, disable the add to cart button
// If the quantity is not 0, enable the add to cart button

function qtyCartCheck(dataCartContents, selectedVariant) {
  if (productCheck) {
    let dataLineItems = dataCartContents.querySelectorAll(".line-item");
    console.log("dataLineItems = " + dataLineItems);
    dataLineItems.forEach((item) => {
      qtyInCart(item);
    }); 
  }
  let selectedVariantId = selectedVariant.id;
  lineItemCheck(dataCartContents, selectedVariantId);
}

function lineItemCheck(dataCartContents, selectedVariantId) {
  if (productCheck) {

    let dataLineItems = dataCartContents.querySelectorAll(".line-item"),
      // 1. Loop through cart items, get id of each, make an array of ids
      itemIds = Array.from(dataLineItems).map((item) => item.dataset.id),
      addToCartForm = document.getElementById("add-to-cart-form"),
      quantityInput = addToCartForm.querySelector("quantity-input input"),
      addToCartButton = addToCartForm.querySelector(".add-to-cart-button"),
      selectedVariantAvailability = document.querySelector(".js-availability").value;

    console.log("itemIds = " + itemIds);
    console.log("selectedVariant.id = " + selectedVariantId);

    if (itemIds.includes(selectedVariantId)) {
      // 3. If cart array contains selectedVariant, review the cart and update the quantity input with the new quantity
      console.log("selected variant id is in the cart")

      // let variantInCartAlt = dataLineItems.find(item => item.dataset.id === selectedVariantId),
      let variantInCart = dataCartContents.querySelector(
          ".line-item[data-id='" + selectedVariantId + "']",
        ),
        lineItemQty = variantInCart.querySelector(".js-line-quantity input").value,
        selectedVariantQty = document.querySelector(".js-variant-qty").value,
        selectedVariantManagement = document.querySelector(".js-variant-management").value,
        newQty = selectedVariantQty - lineItemQty,
        addToCartDisabled = addToCartButton.querySelector(".disabled-text"),
        qtyToUpdate = 0;

      // console.log("variantInCart = " + variantInCart);

      if (selectedVariantManagement) {
        qtyToUpdate = newQty;
        console.log("qtyToUpdate = " + qtyToUpdate);
        quantityInput.setAttribute("max", newQty);

        // 4 If the remaining quantity is 0, disable the add to cart button
        if (newQty <= 0) {
          addToCartButton.setAttribute("disabled", "");
          addToCartButton.classList.add("disabled--button");
          addToCartButton.classList.add("disabled--item-in-cart");
          addToCartButton.querySelector("span.disabled-text").textContent = addToCartButton.dataset.inCart;
          console.log("selected variant is in cart and quantity remaoining is 0 - disable button");
        } else {
          // 5 If the remaining quantity is more than 0, enable the add to cart button
          addToCartButton.classList.remove("disabled--item-in-cart");
          // console.log('quantity is not 0, enable cart ajax button')
          addToCartButton.removeAttribute("disabled");
          addToCartButton.classList.remove("disabled--button");
          addToCartButton.classList.remove("disabled--item-in-cart");
          addToCartButton.querySelector("span.disabled-text").textContent = addToCartButton.dataset.cta;
          // console.log("selected variant is in cart and quantity remaining is more than 0 - enable button");
        }
      } else if (selectedVariantAvailability === "true") {
        // console.log("selectedVariantManagement should be empty[" + selectedVariantManagement + "] availability is " + selectedVariantAvailability + " - continue");

        if (addToCartButton.classList.contains("disabled--item-in-cart")) {
          addToCartButton.classList.remove("disabled--item-in-cart");
          addToCartButton.querySelector("span.disabled-text").textContent =
            "Sold Out";
        }

        if (addToCartButton.classList.contains("disabled--sold-out")) {
          return;
        } else {
          addToCartButton.removeAttribute("disabled");
          addToCartButton.classList.remove("disabled--button");
        }
      } else {
        // Item is not available - disable the button
        addToCartButton.setAttribute("disabled", "");
        addToCartButton.classList.add("disabled--button");
        addToCartButton.classList.add("disabled--sold-out");
        addToCartButton.querySelector("span.disabled-text").textContent = "Sold Out";
      }
    } else {
      // console.log("selectedVariant is NOT in the cart")
      // 5. If the selected variant id is not in the array, reset any changes to the add to cart button

      if (addToCartButton.classList.contains("disabled--item-in-cart")) {
        addToCartButton.classList.remove("disabled--item-in-cart");
        addToCartButton.querySelector("span.disabled-text").textContent =
          "Sold Out";
      }

      // Check if item is actually available before enabling
      if (selectedVariantAvailability === "true") {
        addToCartButton.removeAttribute("disabled");
        addToCartButton.classList.remove("disabled--button");
        addToCartButton.classList.remove("disabled--sold-out");
      } else {
        // Item is not available - keep disabled
        addToCartButton.setAttribute("disabled", "");
        addToCartButton.classList.add("disabled--button");
        addToCartButton.classList.add("disabled--sold-out");
        addToCartButton.querySelector("span.disabled-text").textContent = "Sold Out";
      }
    }
  }
}

function qtyInCart(item) {
  if (productCheck) {
    
    let lineItemId = item.querySelector(".js-variant-input-id").value,
    lineItemQty = item.querySelector(".js-line-quantity").value,
    selectedVariantId = document.querySelector(".js-variant-id").value,
    selectedVariantQty = document.querySelector(".js-variant-qty").value,
    newQty = selectedVariantQty - lineItemQty,
    addToCartForm = document.getElementById("add-to-cart-form"),
    addToCartButton = addToCartForm.querySelector(".add-to-cart-button"),
    addToCartDisabled = addToCartButton.querySelector(".disabled-text");

    if (lineItemId === selectedVariantId) {
      // console.log("matches");

      // console.log("selectedVariantQty = " + selectedVariantQty);
      // console.log("lineItemQty = " + lineItemQty);
      // console.log("newQty = " + newQty);

      let quantityInput = addToCartForm.querySelector("quantity-input input");

      qtyToUpdate = newQty;
      // console.log("qtyToUpdate = " + qtyToUpdate);
      quantityInput.setAttribute("max", newQty);

      if (newQty <= 0) {
        // console.log('quantity is now 0, stop cart ajax button')
        addToCartButton.setAttribute("disabled", "");
        addToCartButton.classList.add("disabled--button");
        addToCartButton.classList.add("disabled--item-in-cart");
        // console.log("this is in cart");

        addToCartButton.querySelector("span.disabled-text").textContent =
          addToCartButton.dataset.inCart;
      } else {
        addToCartButton.classList.remove("disabled--item-in-cart");
        // console.log('quantity is not 0, enable cart ajax button')
        addToCartButton.removeAttribute("disabled");
        addToCartButton.classList.remove("disabled--button");
        addToCartButton.classList.remove("disabled--item-in-cart");
        addToCartButton.querySelector("span.disabled-text").textContent =
          "Sold Out";
      }
    } else {
      // console.log("no match");

      if (addToCartButton.classList.contains("disabled--item-in-cart")) {
        addToCartButton.classList.remove("disabled--item-in-cart");
        addToCartButton.querySelector("span.disabled-text").textContent =
          "Sold Out";
      }

      if (addToCartButton.classList.contains("disabled--sold-out")) {
        return;
      } else {
        addToCartButton.removeAttribute("disabled");
        addToCartButton.classList.remove("disabled--button");
      }
    }
  }
}
